import type {ReactNode} from 'react'
import {useStickySidebar} from './hooks/use-sticky-sidebar'

interface StickySidebarProps {
  children: ReactNode
  topOffset?: number
}

/**
 * A component that creates a sticky sidebar with intelligent scroll direction response
 *
 * - Sticks to the top (with optional offset) when scrolling up
 * - Maintains position at the bottom of the viewport when scrolling down
 * - Uses IntersectionObserver for optimal performance
 */
export function StickySidebar({children, topOffset = 0}: StickySidebarProps) {
  const topWithNotificationShelf = `calc(${topOffset}px + var(--base-sticky-header-height, 0px))`

  const {styles, ref} = useStickySidebar({topOffset: topWithNotificationShelf})

  return (
    <div ref={ref} style={styles} data-testid="sticky-sidebar">
      {children}
    </div>
  )
}

try{ StickySidebar.displayName ||= 'StickySidebar' } catch {}